import React, { useCallback, useEffect, useState, useRef } from 'react';
import { Grid, makeStyles, Typography, CircularProgress } from "@material-ui/core";
import Paginacao from '../../../shared/components/Paginacao';
import Loading from "../../../shared/components/Loading"
import ScrollBarGradiente from "../../../shared/components/ScrollBarGradiente";
import { formatarValorCasasDecimais } from '../../../shared/utils/Formatacao';
import ListaAmostras from "./ListaAmostras";
import AmostrasFiltros from "./AmostrasFiltros";
import AmostrasManager from "../AmostrasManager";
import { v4 as uuidv4 } from 'uuid';
import ReactDOM from "react-dom";
import moment from "moment";
import ContainerPagina from "../../../shared/components/ContainerPagina";
import ModalArquivosAmostra from "./ModalArquivosAmostra";
import { substituirElementoArray } from "../../../shared/utils/ArrayUtil";
import { Download } from 'react-feather';
import LinkButton from "../../../shared/components/LinkButton";
import { SECONDARY_COLOR } from '../../../theme';
import store from '../../../store';
import { mensagemAlertaActions } from '../../mensagemAlerta/redux';
import { iniciarDownload } from '../../../shared/utils/ArquivoUtil';
import { NOME_ARQUIVO_LISTAGEM_DE_AMOSTRAS } from '../../../shared/utils/Constantes';

const PAGINA_INICIAL = 1
const ITENS_PAGINA_INICIAL = 15;

const filtrosIniciais = () => ({
    busca: '',
    tipos: [],
    status: [],
    dataInicio: moment().subtract(15, 'd'),
    dataFinal: moment()
});

const Amostras = (props) => {

    const classes = useStyles();
    const [listaAmostras, setListaAmostras] = useState([]);
    const [tiposOpcoes, setTiposOpcoes] = useState([]);
    const [statusOpcoes, setStatusOpcoes] = useState([]);
    const [possuiAmostras, setPossuiAmostras] = useState(true);
    const [indexPaginaAtual, setIndexPaginaAtual] = useState(0);
    const [carregandoAmostras, setCarregandoAmostras] = useState(true);
    const [quantidadeTotalItens, setQuantidadeTotalItens] = useState(null);
    const [quantidadeItensPorPagina, setQuantidadeItensPorPagina] = useState(ITENS_PAGINA_INICIAL);
    const contadorCarregandoAmostras = useRef(0);
    const ultimoUUIDRequisicao = useRef("");
    const filtrosRef = useRef(filtrosIniciais());
    const [filtros, setFiltros] = useState(filtrosIniciais());
    const [listaArquivos, setListaArquivos] = useState([]);
    const [carregandoArquivos, setCarregandoArquivos] = useState(false);
    const [modalArquivosAberta, setModalArquivosAberta] = useState(false);
    const [dadosAmostraModal, setDadosAmostraModal] = useState([]);
    const [carregandoPlanilha, setCarregandoPlanilha] = useState(false);

    const [ordenacao, setOrdenacao] = useState({
        coluna: 'DataCadastro',
        decrescente: true
    });

    const [paginacao, setPaginacao] = useState({
        pagina: PAGINA_INICIAL,
        itensPagina: ITENS_PAGINA_INICIAL,
    });

    const retornoDesabilitado = carregandoAmostras || indexPaginaAtual === 0

    const avancoDesabilitado =
        !possuiAmostras ||
        carregandoAmostras ||
        (listaAmostras && listaAmostras.length < quantidadeItensPorPagina) ||
        listaAmostras.length === quantidadeTotalItens;

    const incrementarContadorCarregandoAmostras = useCallback(() => {
        contadorCarregandoAmostras.current++;
        setCarregandoAmostras(true);
    }, [])

    const decrementarContadorCarregandoAmostras = useCallback(() => {
        if (contadorCarregandoAmostras.current > 0) {
            contadorCarregandoAmostras.current--;
        }
        if (contadorCarregandoAmostras.current === 0) {
            setCarregandoAmostras(false);
        }
    }, [])

    const listarAmostras = useCallback(async (filtrosParam, ordenacaoParam, paginacaoParam) => {
        incrementarContadorCarregandoAmostras();

        const operacoesListagem = {
            filtros: filtrosParam,
            ordenacao: ordenacaoParam,
            paginacao: paginacaoParam,
        }
        ultimoUUIDRequisicao.current = uuidv4();
        const resultado = await AmostrasManager.listarAmostras(operacoesListagem, ultimoUUIDRequisicao.current);

        if (resultado && resultado.itens && resultado.itens.length > 0) {
            if (resultado.uuid === ultimoUUIDRequisicao.current) {
                setListaAmostras(resultado.itens);
                setPossuiAmostras(true);
            }
        }
        else {
            setListaAmostras([]);
            setPossuiAmostras(false);
        }

        setQuantidadeTotalItens(resultado.totalItens)
        decrementarContadorCarregandoAmostras();
    }, [incrementarContadorCarregandoAmostras, decrementarContadorCarregandoAmostras])

    const handleClickBaixarPlanilha = async () => {
        setCarregandoPlanilha(true);

        const operacoesListagem = {
            filtros: filtros,
            ordenacao: ordenacao,
        }

        await AmostrasManager.baixarPlanilha(operacoesListagem)
            .then((resposta) => {
                const nomeArquivo = NOME_ARQUIVO_LISTAGEM_DE_AMOSTRAS + moment().format('DDMMYYYYHHmmss');
                iniciarDownload(resposta, nomeArquivo);
            })
            .finally(() => setCarregandoPlanilha(false));
    }

    const obterPaginaInicial = () => {
        if (listaAmostras && listaAmostras.length === 0) return 0

        const paginaAtual = indexPaginaAtual === 0 ? 1 : indexPaginaAtual

        return formatarValorCasasDecimais((paginaAtual - PAGINA_INICIAL) * quantidadeItensPorPagina + 1)
    }

    const obterPaginaFinal = () => {
        if (listaAmostras && listaAmostras.length === 0) return 0

        const paginaAtual = indexPaginaAtual === 0 ? 1 : indexPaginaAtual
        return formatarValorCasasDecimais((paginaAtual - PAGINA_INICIAL) * quantidadeItensPorPagina + listaAmostras.length)
    }

    const handleChangeItensPorPagina = (event) => {
        setQuantidadeItensPorPagina(event.target.value)
        setPaginacao({
            ...paginacao,
            pagina: PAGINA_INICIAL,
            itensPagina: event.target.value,
        })

        setListaAmostras([]);
        setIndexPaginaAtual(0);
    }

    const handleChangePagina = (avanco) => {
        const paginaAtual = indexPaginaAtual === 0 ? 1 : indexPaginaAtual
        const paginaAVisualizar = avanco ? paginaAtual + 1 : paginaAtual - 1
        setIndexPaginaAtual(paginaAVisualizar === 1 ? 0 : paginaAVisualizar)
        setPaginacao({
            ...paginacao,
            pagina: paginaAVisualizar,
            itensPagina: quantidadeItensPorPagina,
        })

        setListaAmostras([]);
    }

    const voltarPaginaInicial = () => {
        setPaginacao({
            ...paginacao,
            pagina: PAGINA_INICIAL,
        })
        setIndexPaginaAtual(0);
    }

    const handleOrdenacao = () => {
        voltarPaginaInicial();
        setOrdenacao({
            ...ordenacao,
            decrescente: !ordenacao.decrescente,
        });
    }

    const handleChangeFiltros = (novosFiltros) => {
        const filtrosMudaram =
            novosFiltros.busca !== filtrosRef.current.busca ||
            (!novosFiltros.dataInicio?.isSame(filtrosRef.current.dataInicio, "date")) ||
            (!novosFiltros.dataFinal?.isSame(filtrosRef.current.dataFinal, "date")) ||
            (filtrosRef.current.tipos && novosFiltros.tipos.length !== filtrosRef.current.tipos.length) ||
            (filtrosRef.current.status && novosFiltros.status.length !== filtrosRef.current.status.length);

        if (filtrosMudaram) {
            filtrosRef.current = novosFiltros;

            ReactDOM.unstable_batchedUpdates(() => {
                setFiltros(novosFiltros);

                if (paginacao.pagina !== PAGINA_INICIAL)
                    voltarPaginaInicial();
            });
        }
    };

    const abrirModalArquivos = async (item) => {

        setModalArquivosAberta(true);
        setCarregandoArquivos(true);
        setDadosAmostraModal(item);

        const arquivos = await AmostrasManager.listarArquivos(item.id);

        setListaArquivos(arquivos || []);

        setCarregandoArquivos(false);
    }

    const atualizarArquivoNaLista = (arquivoAtualizado) => {
        setListaArquivos((prev) => {
            const arquivos = [...prev];
            return substituirElementoArray(
                arquivos,
                arquivoAtualizado,
                (arq) => arq.id === arquivoAtualizado.id
            );
        });
    }

    const handleBaixarArquivo = async (arquivo) => {
        atualizarArquivoNaLista({ ...arquivo, baixando: true });
        await AmostrasManager.baixarArquivos(arquivo.idAmostra, arquivo.id, arquivo.nome);
        atualizarArquivoNaLista({ ...arquivo, baixando: false });
    }

    const handleFecharModal = () => {
        setModalArquivosAberta(false);
    }

    useEffect(() => {
        AmostrasManager.listarTipos().then(tipos => setTiposOpcoes(tipos));
        AmostrasManager.listarStatus().then(status => setStatusOpcoes(status));
    }, [])

    useEffect(() => {
        if (!filtros.dataInicio || !filtros.dataFinal) {
            store.dispatch(mensagemAlertaActions.exibirNotificacao("Para pesquisar, selecione um período máximo de 31 dias."));
            return;
        }

        listarAmostras(filtros, ordenacao, paginacao);
    }, [listarAmostras, filtros, ordenacao, paginacao]);

    return (
        <ContainerPagina>
            <ModalArquivosAmostra
                amostra={dadosAmostraModal}
                arquivos={listaArquivos}
                modalAberta={modalArquivosAberta}
                carregandoArquivos={carregandoArquivos}
                handleFecharModal={handleFecharModal}
                handleBaixarArquivo={handleBaixarArquivo}
            />
            <Grid container>
                <Grid item xs={6}>
                    <Typography variant="h2" className="mt-4 mb-8">
                        Listagem de amostras
                    </Typography>
                </Grid>

                <Grid item xs={12} className="pb-2">
                    <AmostrasFiltros
                        tiposOpcoes={tiposOpcoes}
                        statusOpcoes={statusOpcoes}
                        filtros={filtros}
                        handleChangeFiltros={handleChangeFiltros}
                    />
                </Grid>

                {carregandoAmostras ?
                    (<Grid item xs={12} className={classes.loading}>
                        <Loading loading size={30} className={"mt-0 mb-0"} />
                    </Grid>) :
                    (<Grid item xs={12} className={classes.containerTabela}>
                        <ScrollBarGradiente
                            estilo={{
                                height: "100%",
                                width: "100%",
                            }}
                            larguraGradiente={"0"}
                        >
                            <ListaAmostras
                                listaAmostras={listaAmostras}
                                handleOrdenacao={handleOrdenacao}
                                ordemDecrescente={ordenacao.decrescente}
                                handleArquivosAmostra={abrirModalArquivos}
                            />
                        </ScrollBarGradiente>
                    </Grid>)
                }
                <Grid item container xs={12} className={classes.paginacao}>
                    <Grid item xs={8} >
                        <Paginacao
                            quantidadeItensPorPagina={quantidadeItensPorPagina}
                            retornoDesabilitado={retornoDesabilitado}
                            avancoDesabilitado={avancoDesabilitado}
                            quantidadeTotalItens={quantidadeTotalItens === null ? 0 : formatarValorCasasDecimais(quantidadeTotalItens)}
                            inicioPagina={() => obterPaginaInicial()}
                            finalPagina={() => obterPaginaFinal()}
                            handleChangeSelect={(event) => handleChangeItensPorPagina(event)}
                            mudarPagina={handleChangePagina}
                            textoExibicao="Exibindo amostras"
                        />
                    </Grid>
                    <Grid item container xs={4} justify="flex-end">
                        <LinkButton
                            label="Exportar lista de amostras"
                            icone={
                                carregandoPlanilha
                                    ? <CircularProgress size={24} />
                                    : <Download color={SECONDARY_COLOR} />
                            }
                            onClick={handleClickBaixarPlanilha}
                            desabilitado={carregandoPlanilha}
                            fontSize={16}
                            className={classes.botaoBaixarPlanilha}
                        />
                    </Grid>
                </Grid>
            </Grid>
        </ContainerPagina>
    );
}

const useStyles = makeStyles((theme) => ({
    containerTabela: {
        height: "calc(90vh - 225px)"
    },
    loading: {
        height: "calc(100vh - 320px)",
        display: "flex",
        alignItems: "center",
    },
    paginacao: {
        paddingTop: "10px"
    }
}))

export default Amostras;